import React, { useState } from "react";
import logo from "../../views/Components/HeroSection/assets/logo.png";
import { useNavigate } from "react-router-dom";
import "../../css/landing.css";

const Header = ({ isContainer = false }) => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  return (
    <div>
      <nav className="navbar">
        <div className={`nav-content ${isContainer ? "container" : ""}`}>
          <div
            className="logo-wrapper cursor-pointer"
            onClick={() => navigate("/")}
          >
            <img className="upskill-logo" src={logo} alt="Upskill Logo" />
          </div>
          <div className="navbar-btn">
            <button
              className="login-btn"
              onClick={() => navigate("/signup-options")}
            >
              Get Started
            </button>
            <button className="signup-btn" onClick={() => navigate("/login")}>
              Sign in
            </button>
          </div>
          <div className="menu" onClick={() => setShowDropdown(!showDropdown)}>
            <div className="menu-line"></div>
            <div className="menu-line"></div>
            <div className="menu-line"></div>
          </div>
        </div>
      </nav>
      <div
        className={`collapse navbar-collapse justify-content-between ${
          showDropdown ? "showdropdown" : ""
        }`}
        id="nav"
      >
        <ul className="navbar-pages">
          {/* <li className="page-link">Home</li>
          <li className="page-link">Professional branding</li> */}

          <div className="navbar-btn">
            <button
              className="login-btn"
              onClick={() => navigate("/signup-options")}
            >
              Get Started
            </button>
            <button className="signup-btn" onClick={() => navigate("/login")}>
              Signin
            </button>
          </div>
        </ul>
      </div>
    </div>
  );
};

export default Header;
